'use client';

import { useCallback } from 'react';

/**
 * Tiny helper — returns the JWT from localStorage and exposes a `fetch`
 * wrapper that attaches it as a Bearer header.
 */
export function useAuthToken() {
  const getToken = useCallback(() => {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem('token');
  }, []);

  const authedFetch = useCallback(
    async (url: string, init: RequestInit = {}) => {
      const token = getToken();
      const headers = new Headers(init.headers);
      if (token) headers.set('Authorization', `Bearer ${token}`);
      if (init.body && !headers.has('Content-Type') && !(init.body instanceof FormData)) {
        headers.set('Content-Type', 'application/json');
      }
      return fetch(url, { ...init, headers });
    },
    [getToken]
  );

  return { getToken, authedFetch };
}
